import Reporter from './Reporter';
import { loadScript } from 'Misc/loaders';
import { expiringRequest } from 'Misc/timing';

export default class JavascriptReporter extends Reporter {
  run() {
    const container = loadScript(this.resource);
    this.inject(container);

    return this.expirer.promise;
  }
}


// WEBPACK FOOTER //
// ./src/Services/Reporting/JavascriptReporter.js